import { useEffect, useState } from "react";
// import rewardd from "../rewardd.jpg";
// import cashback from "../rewardd.jpg";
// import referearn from "../rewardd.jpg"

import ReferEarn from "./ReferEarn";
// import festival from "../rewardd.jpg"
import "./Notifications.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import CouponsTable from "./CouponsTable";
import ReferandearnTable from "./ReferandearnTable";

const Notifications = () => {
  const [activeTab, setActiveTab] = useState("coupons"); // Default tab
  const [coupons, setCoupons] = useState([]);
  const userId = localStorage.getItem("userId"); // Retrieve userId from local storage
  const cashbackData = [
    // { image: cashback, amount: "₹10", message: "Cashback on first order" },
    // { image: rewardd, amount: "₹25", message: "Cashback on second order" },
    // { image: referearn, amount: "₹50", message: "Cashback on referral" },
    // { image: festival, amount: "₹100", message: "Cashback on festive offer" },

  ];

  const navigate = useNavigate();

  useEffect(() => {
    const fetchCoupons = async () => {
      try {
        const userId = localStorage.getItem("userId");
        const token = localStorage.getItem("authToken"); // ✅ Fetch token

        if (!userId) {
          console.error("User ID not found in local storage.");
          return;
        }

        if (!token) {
          console.error("Auth token not found. Please login again.");
          return;
        }

        const response = await axios.get(
          "https://backend.maamaas.com/food/coupon",
          {
            headers: {
              Authorization: `Bearer ${token}`, // ✅ Include token
              Accept: "*/*",
            },
          }
        );
        console.log("Coupon API Response:", response.data);

        if (Array.isArray(response.data)) {
          setCoupons(response.data); // ✅ Save coupons to state
        } else {
          console.error("Unexpected API response format:", response.data);
        }
      } catch (error) {
        console.error("❌ Error fetching coupons:", error);
        alert("Failed to fetch coupons. Please try again later.");
      }
    };

    fetchCoupons();
  }, []);
  // no need for [userId] here, unless userId can change

  const handleApplyCoupon = async (couponId, couponCode) => {
    try {
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("authToken"); // ✅ Fetch token

      if (!userId) {
        alert("❌ User not logged in!");
        return;
      }

      if (!token) {
        alert("❌ Auth token missing. Please login again.");
        return;
      }

      // 🔹 1. Fetch cart details WITHOUT seating
      const cartResWithoutSeating = await axios.get(
        `https://backend.maamaas.com/food/api/cart/${userId}/without-seating`,
        { headers: { Authorization: `Bearer ${token}` } } // ✅ Token added
      );
      console.log("📡 Cart WITHOUT seating API response:", cartResWithoutSeating.data);

      const cartDataWithoutSeating = Array.isArray(cartResWithoutSeating.data)
        ? cartResWithoutSeating.data[0] || {}
        : cartResWithoutSeating.data;

      // 🔹 2. Fetch cart details WITH seating
      const cartResWithSeating = await axios.get(
        `https://backend.maamaas.com/food/api/cart/${userId}/with-seating`,
        { headers: { Authorization: `Bearer ${token}` } } // ✅ Token added
      );
      console.log("📡 Cart WITH seating API response:", cartResWithSeating.data);

      const cartDataWithSeating = Array.isArray(cartResWithSeating.data)
        ? cartResWithSeating.data[0] || {}
        : cartResWithSeating.data;

      // 🔹 3. Determine active cart (prefer without seating)
      const cartDataInitial = cartDataWithoutSeating.cartId
        ? cartDataWithoutSeating
        : cartDataWithSeating;

      if (!cartDataInitial.cartId) {
        alert("❌ No active cart found! Add items first.");
        return;
      }

      const cartId = cartDataInitial.cartId;
      localStorage.setItem("cartId", cartId);
      console.log("📝 Active Cart ID:", cartId);

      // 🔹 4. Prepare request body
      const body = {
        id: Number(couponId),
        applyCoupon: "APPLIED",
      };
      console.log("Request body for apply:", body);

      // 🔹 5. Apply coupon
      const applyResponse = await axios.put(
        `https://backend.maamaas.com/food/api/cart/coupon/${cartId}`,
        body,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // ✅ Token added
          },
        }
      );
      console.log("✅ Applied Coupon Response:", applyResponse.data);

      if (applyResponse.data) {
        // ✅ Store coupon details locally
        localStorage.setItem(
          "appliedCoupon",
          JSON.stringify({
            id: couponId,
            code: couponCode,
            details: applyResponse.data,
          })
        );

        // 🔹 6. Conditional navigation based on seatingId
        console.log("🔹 seatingId from WITH seating cart:", cartDataWithSeating.seatingId);

        const cartDataFinal =
          cartDataWithSeating.cartId &&
            cartDataWithSeating.seatingId &&
            cartDataWithSeating.seatingId !== 0
            ? cartDataWithSeating
            : cartDataWithoutSeating;

        // Save cartId
        localStorage.setItem("cartId", cartDataFinal.cartId);

        // Conditional navigation
        if (cartDataFinal === cartDataWithSeating) {
          console.log("➡ Redirecting to: /tablecart");
          navigate("/tablecart");
        } else {
          console.log("➡ Redirecting to: /cartsdata");
          navigate("/cartsdata");
        }
      }
    } catch (error) {
      console.error("❌ Error applying coupon:", error.response?.data || error.message);
      alert("Failed to apply coupon. Please try again.");
    }
  };

  const activeTabStyle = {
    ...tabStyle,
    background: "rgb(177, 93, 198)",
    color: "white",
  };

  return (
    <div>
      <div style={{ marginTop: "30px" }}>
        <div style={{
          // marginLeft: "-98px",

          //   height: "540px",
          scrollbarWidth: "none"
        }} className="notificationpage-scroll-data">

          {/* Tab Buttons */}
          <div
            className="tab-buttons-container"
            style={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap", // Optional, allows wrapping on smaller widths
              marginBottom: "20px",
              // marginLeft: "59px",
              gap: "10px", // Adds space between buttons
            }}
          >
            <button
              onClick={() => setActiveTab("coupons")}
              style={activeTab === "coupons" ? activeTabStyle : tabStyle}
            >
              Coupons
            </button>
            {/* <button
              onClick={() => setActiveTab("rewards")}
              style={activeTab === "rewards" ? activeTabStyle : tabStyle}
            >
              Rewards
            </button> */}
            <button
              onClick={() => setActiveTab("refer")}
              style={activeTab === "refer" ? activeTabStyle : tabStyle}
            >
              Refer & Earn
            </button>
            {/* <button
                            onClick={() => setActiveTab("cashback")}
                            style={activeTab === "cashback" ? activeTabStyle : tabStyle}
                        >
                            Cashback
                        </button> */}
          </div>


          {/* Coupons Section */}
          {activeTab === "coupons" && (
            <div className="card-container">
              {coupons.map((coupon) => (
                <div key={coupon.id} style={cardStyle}>
                  <div>
                    <p style={{ margin: "5px 0", fontSize: "20px", opacity: "0.8", fontWeight: "bold", color: "#000" }}>
                      {coupon.discountPercentage}% OFF
                    </p>
                    <p style={{ margin: "5px 0", fontSize: "12px", fontWeight: "bold", color: "red" }}>
                      Code: {coupon.code}
                    </p>
                  </div>
                  <button
                    style={buttonStyle}
                    onClick={() => handleApplyCoupon(coupon.id, coupon.code)}
                  >
                    Apply
                  </button>
                </div>
              ))}
            </div>
          )}



          {/* Rewards Section */}
          {activeTab === "rewards" && (
            <div style={{
              padding: "0 15px",
              maxWidth: "100%",
              overflowX: "hidden"
            }}>
              <div style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px"
              }}>
                {Array.from({ length: 1 }, (_, rowIndex) => (
                  <div key={rowIndex} style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
                    gap: "16px",
                    width: "100%",
                    "@media (maxWidth: 320px)": {
                      gridTemplateColumns: "1fr"
                    },
                    "@media (minWidth: 480px) and (maxWidth: 767px)": {
                      gridTemplateColumns: "repeat(2, 1fr)"
                    },
                    "@media (minWidth: 768px) and (maxWidth: 1023px)": {
                      gridTemplateColumns: "repeat(3, 1fr)"
                    },
                    "@media (minWidth: 1024px)": {
                      gridTemplateColumns: "repeat(4, 1fr)"
                    }
                  }}>
                    {[0, 1, 2, 3].map((_, colIndex) => {
                      const index = rowIndex * 4 + colIndex;
                      return (
                        <div key={index} style={{
                          minWidth: "0",
                          overflow: "hidden"
                        }}>
                          <div style={{
                            background: "#ffffff",
                            borderRadius: "12px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            overflow: "hidden",
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                            transition: "transform 0.3s ease",
                            ":hover": {
                              transform: "translateY(-5px)"
                            },
                            "@media (maxWidth: 320px)": {
                              maxWidth: "280px",
                              margin: "0 auto"
                            }
                          }}>
                            <img
                              // src={rewardd}
                              alt="reward"
                              style={{
                                width: "100%",
                                height: "120px",
                                objectFit: "cover",
                                "@media (maxWidth: 320px)": {
                                  height: "100px"
                                },
                                "@media (minWidth: 768px) and (maxWidth: 1023px)": {
                                  height: "140px"
                                },
                                "@media (minWidth: 1024px) and (maxWidth: 1439px)": {
                                  height: "160px"
                                },
                                "@media (minWidth: 1440px)": {
                                  height: "180px"
                                }
                              }}
                            />
                            <div style={{
                              padding: "12px",
                              background: "linear-gradient(135deg, #6e8efb, #a777e3)",
                              color: "white",
                              flexGrow: "1",
                              "@media (minWidth: 1024px)": {
                                padding: "15px"
                              }
                            }}>
                              <h4 style={{
                                fontSize: "18px",
                                fontWeight: "bold",
                                marginBottom: "4px",
                                "@media (maxWidth: 320px)": {
                                  fontSize: "16px"
                                },
                                "@media (minWidth: 1440px)": {
                                  fontSize: "20px",
                                  marginBottom: "8px"
                                }
                              }}>₹10 - ₹100</h4>
                              <p style={{
                                fontSize: "14px",
                                marginBottom: "0",
                                "@media (maxWidth: 320px)": {
                                  fontSize: "12px"
                                },
                                "@media (minWidth: 1440px)": {
                                  fontSize: "16px"
                                }
                              }}>Cashback on next delivery</p>
                            </div>
                            <div style={{
                              padding: "12px",
                              background: "white"
                            }}>
                              <button style={{
                                width: "100%",
                                background: "white",
                                color: "#333",
                                border: "1px solid #ddd",
                                fontWeight: "500",
                                padding: "8px",
                                borderRadius: "4px",
                                transition: "all 0.3s ease",
                                ":hover": {
                                  background: "#f5f5f5",
                                  borderColor: "#ccc"
                                }
                              }}>Apply</button>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Refer & Earn Section */}
          {activeTab === "refer" && (
            <div style={{ maxHeight: "400px", overflowY: "auto", scrollbarWidth: "none" }}>
              <ReferEarn />
              {/* <ReferandearnTable /> */}
            </div>
          )}




          {activeTab === "cashback" && (
            <div>
              {/* <h3 style={{ fontWeight: "bold", marginLeft: "40px", marginTop: "30px", marginBottom: "20px" }}>Rewards</h3> */}

              <div
                //  style={{ marginLeft: "60px", marginRight: "-60px", }} 
                className="reward-data">
                <div className="row g-4">
                  {cashbackData.map((item, index) => (
                    <div key={index} className="col-lg-3 col-md-6 col-sm-12">
                      <div style={rewardCardStyle}>
                        <img style={rewardImageStyle} src={item.image} alt="reward" />
                        <div className="cashback">
                          <h4 className="rupee">{item.amount}</h4>
                          <p style={{ color: "#fff", fontSize: "14px" }}>{item.message}</p>


                        </div>
                        <div className="d-flex justify-content-center">
                          <Button className="mt-1" style={{ backgroundColor: "white", color: "black" }}>Apply</Button>
                        </div>
                      </div>

                    </div>
                  ))}
                </div>

              </div>
              <CouponsTable />
            </div>
          )}
        </div>




        <div
          style={{
            position: "fixed",
            bottom: "0px",
            left: "0px",
            height: '30px',
            width: "100%",
            backgroundColor: "white",
            color: "black",
            textAlign: "center",
            padding: "5px",
            fontWeight: "bold",
            fontSize: "14px",
            boxShadow: "0 -2px 5px rgba(0, 0, 0, 0.1)",
            zIndex: "999"
          }}
        >
          @Envision Integrated Services Pvt Ltd - Empowering Your Future 🚀
        </div>

      </div>
    </div>
  );
};
// Card Styles
const cardContainerStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)", // Default: 4 cards per row
  gap: "35px",
  justifyContent: "center",
  alignItems: "center",
  marginTop: "20px",
  padding: "0 20px",
  marginLeft: "60px",

  /* Responsive Design */
  "@media (max-width: 1024px)": {
    gridTemplateColumns: "repeat(2, 1fr)", // 2 cards per row on tablets
  },
  "@media (max-width: 768px)": {
    gridTemplateColumns: "repeat(1, 1fr)", // 1 card per row on mobile
    marginLeft: "0px", // Adjust margin for better centering
    padding: "0 10px", // Reduce padding on small screens
  }
};


const cardStyle = {
  // width: "210px",
  height: "150px",
  background: "#fff",
  borderRadius: "12px",
  padding: "15px",
  color: "#333",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "center",
  textAlign: "center",
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
  position: "relative",
  border: "2px dashed rgb(177, 93, 198)",
  overflow: "hidden"
};


// **Creating the "cutout" effect on sides**
const cutoutStyle = {
  position: "absolute",
  width: "25px",
  height: "25px",
  backgroundColor: "#fff",
  borderRadius: "50%",
  top: "50%",
  transform: "translateY(-50%)",
  boxShadow: "0 0 5px rgba(0,0,0,0.1)"
};

const buttonStyle = {
  marginTop: "10px",
  background: "rgb(177, 93, 198)",
  color: "#fff",
  // height: "70px",  // Increased height
  width: "120px",  // Increased width for better proportion
  border: "none",
  borderRadius: "8px",
  fontWeight: "bold",
  fontSize: "20px",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "4px"
};

// Styles
const tabStyle = {
  padding: "10px 20px",
  border: "none",
  background: "#ddd",
  cursor: "pointer",
  margin: "0 10px",
  borderRadius: "5px",
  fontSize: "24px"
};


const rewardCardStyle = { width: "200px", height: "220px", background: "rgb(177, 93, 198)", borderRadius: "20px" };
const rewardImageStyle = { width: "200px", height: "120px", borderTopLeftRadius: "20px", borderTopRightRadius: "20px" };
const referImageStyle = { width: "733px", height: "330px", marginBottom: "20px", marginLeft: "66px", borderRadius: "30px", border: "2px solid #000" };
const inviteHeadingStyle = { fontSize: "20px", fontWeight: "bold", color: "#4A235A", marginBottom: "10px", fontFamily: "sans-serif" };
const inputStyle = { width: "320px", padding: "12px", borderRadius: "25px", border: "2px solid #B16DC6", fontSize: "16px", textAlign: "center", outline: "none", transition: "0.3s", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)" };
const submitButtonStyle = { display: "block", margin: "15px auto", padding: "12px 24px", backgroundColor: "rgb(177, 93, 198)", color: "#fff", border: "none", borderRadius: "25px", cursor: "pointer", fontSize: "16px", fontWeight: "bold", transition: "0.3s", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)" };



export default Notifications;

